import * as Highcharts from 'highcharts';
import { provideHighcharts } from 'highcharts-angular';
import { HighchartsChartComponent } from 'highcharts-angular';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AngularSignaturePadModule } from '@mineminemine/angular-signature-pad';
import { AppRoutingModule } from './app-routing.module';
import { environment } from '../environments/environment';

// Material
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { DateAdapter, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';

// Service
import { NgxImageCompressService } from 'ngx-image-compress';
import { CustomDateAdapter } from './common/custom-date-adapter';

// Components
import { AppComponent } from './app.component';
import { ConfirmDialogComponent } from './dialogs/confirm-dialog/confirm-dialog.component';
import { PasswordChangeComponent } from './password-change/password-change.component';
import { LoginComponent } from './login/login.component';
import { SingleEntryDialogComponent } from './dialogs/single-entry-dialog/single-entry-dialog.component';
import { NotificationDialogComponent } from './dialogs/notification-dialog/notification-dialog.component';
import { AiSuggestionDialogComponent } from './dialogs/ai-suggestion-dialog/ai-suggestion-dialog.component';
import { AiActionSuggestionDialogComponent } from './dialogs/ai-action-suggestion-dialog/ai-action-suggestion-dialog.component';
import { ImagePopupDialogComponent } from './dialogs/image-popup-dialog/image-popup-dialog.component';
import { ListOptionDialogComponent } from './dialogs/list-option-dialog/list-option-dialog.component';
import { SelectOptionDialogComponent } from './dialogs/select-option-dialog/select-option-dialog.component';
import { MainComponent } from './main/main.component';
import { LegalAgreementComponent } from './legal/legal-agreement.component';

@NgModule({
  declarations: [
    AppComponent,
    ConfirmDialogComponent,
    PasswordChangeComponent,
    LoginComponent,
    SingleEntryDialogComponent,
    NotificationDialogComponent,
    AiSuggestionDialogComponent,
    AiActionSuggestionDialogComponent,
    ImagePopupDialogComponent,
    ListOptionDialogComponent,
    SelectOptionDialogComponent,
    MainComponent,
    LegalAgreementComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCardModule,
    MatRadioModule,
    MatMenuModule,
    MatIconModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatDividerModule,
    MatNativeDateModule,
    HighchartsChartComponent,
    AngularSignaturePadModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    provideHighcharts({ instance: () => Promise.resolve(Highcharts) }),
    NgxImageCompressService,
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { subscriptSizing: 'dynamic' } }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
